import axios from "axios";
import { BASE_URL, getAxiosConfig } from "../components/interface/Config";
import { UserData } from "../components/interface/providerinterface";
import { apiHandler } from "./authService";

export const fetchUserInfo = async () => {
  try {
    const authToken = sessionStorage.getItem('authToken'); // Get token from sessionStorage
    if (!authToken) {
      throw new Error("No authorization token found");
    }

    // const response = await axios.get(`${BASE_URL}/users/info`, getAxiosConfig());
    const url       = `${BASE_URL}/users/info`;
    const response  = await apiHandler(authToken, 'GET', {}, url);
    if (!response) {
      throw new Error("No Data");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching user info:", error);
    throw error;
  }
};

export const fetchMasters = async () => {
  try {
    const authToken = sessionStorage.getItem('authToken'); // Get token from sessionStorage
    if (!authToken) {
      throw new Error("No authorization token found");
    }
    const url       = `${BASE_URL}/resource/masters/all?slug=country&order_by=name&dir=1`;
    const response  = await apiHandler(authToken, 'GET', {}, url);
    if (!response) {
      throw new Error("No Data");
    }
    return response.data;

    // const response = await axios.get(
    //   `${BASE_URL}/resource/masters/all?slug=country&order_by=name&dir=1`,
    //   getAxiosConfig()
    // );

  } catch (error) {
    console.error("Error fetching masters:", error);
    throw error;
  }
};

export const fetchTimezones = async () => {
  try {
    const authToken = sessionStorage.getItem('authToken'); // Get token from sessionStorage
    if (!authToken) {
      throw new Error("No authorization token found");
    }

    const url       = `${BASE_URL}/resource/timezone/all`;
    const response  = await apiHandler(authToken, 'GET', {}, url);
    if (!response) {
      throw new Error("No Data");
    }
    return response.data;

    // const response = await axios.get(`${BASE_URL}/resource/timezone/all`, getAxiosConfig());
    // return response.data;
  } catch (error) {
    console.error("Error fetching timezones:", error);
    throw error;
  }
};


/**
 * Updates the user information.
 * @param userId - The ID of the user to update.
 * @returns The updated user data.
 */

export const updateUser = async (userId: number, payload: any) => {
  try {
    const authToken = sessionStorage.getItem("authToken");
    if (!authToken) {
      throw new Error("No authorization token found");
    }

    console.log("Sending Payload:", payload);  // Add this line to log payload

    const url       = `${BASE_URL}/resource/users/${userId}`;
    const response  = await apiHandler(authToken, 'PUT',payload, url);

    if (!response) {
        throw new Error("No response received from the server");
    }

    // const response = await axios.put(
    //   `${BASE_URL}/resource/users/${userId}`,
    //   payload,
    //   getAxiosConfig()
    // );

    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};


